import dashboard from "./dashboard";
import pages from "./pages";
import configuration from "./configurations";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, pages, configuration]
};

export default menuItems;
